const RouteNames = {
  ADMINISTRATION: 'administration',
  CONTRACT_STATUS: 'contractStatus',
  DATASOURCE_DATALOGGER: '/dataSource/datalogger/',
  DATASOURCE_DATALOGGER_OVERVIEW: 'dataloggerOverview',
  DATALOGGER: 'datalogger',
  NEW_SYSTEM: 'newSystem',
  PAGE_NOT_FOUND: 'pageNotFound',
  BASE: 'base',
  START: 'start',
  BACKUP_CONFIG: 'backupConfig',
  INVERTER_STRING_MONITORING: 'inverterStringMonitoring',
  DIGITAL_SIGNALS: 'digitalSignals',
  SYSTEM_TECHNICAL_DATA: 'systemTechnicalOverview',
  BATTERY_INVERTER_ASSIGNMENTS: 'batteryInverterAssignment',
  PERFORMANCE_RATIO: 'performanceRatio',
  PERFORMANCE_RATIO_EDITOR: 'performanceRatioEditor',
  PERFORMANCE_RATIO_CHART_SETTINGS: 'performanceRatioChartSettings',
  PERFORMANCE_RATIO_MISSING_ENERGY_SOURCE: 'performanceRatioMissingEnergySource',
};

export default RouteNames;
